export const ROLES = {
  BROKER: "broker",
  CLAIMS_HANDLER: "claim_handler",
  UNDERWRITER: "underwriter",
};

export default ROLES;
